import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js';
import { Security, LoginCallback, useOktaAuth } from '@okta/okta-react';
import { OverviewProvider } from './context/OverviewContext';
import { ChecklistProvider } from './context/ChecklistContext';
import { ToolSettingsProvider } from './context/ToolSettingsContext';
import RouteComponent from "./components/Routes";
import config from './config';
import './assets/css/app.css';
import { LinksProvider } from './context/LinksContext';
import { EnrollmentPortalStatusProvider } from './context/EnrollmentPortalStatusContext';

const oktaAuth = new OktaAuth(config.oidc);
const App: React.FC = () => {
      const navigate = useNavigate();

      const restoreOriginalUri = async (_oktaAuth: OktaAuth, originalUri: string) => {
        navigate(toRelativeUrl(originalUri || '/', window.location.origin));
      };
     
      useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const getTokenVal = urlParams.get("t");
        const canvasRedirect = urlParams.get("redirect");

        // console.log("code", urlParams.get("code") );
        // console.log("t", getTokenVal);

        if (getTokenVal) {
          sessionStorage.setItem("authToken", getTokenVal);
          navigate("/", { replace: true });
        } else if (canvasRedirect) {
          navigate("/milestone-1", { replace: true });
        } else {
          console.error("Missing Token");
        }

      }, [navigate]);

      return (
        <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
          <LinksProvider>
            <OverviewProvider>
              <ChecklistProvider>
                <EnrollmentPortalStatusProvider>
                  <ToolSettingsProvider>
                    <RouteComponent /> 
                  </ToolSettingsProvider>
                </EnrollmentPortalStatusProvider>
              </ChecklistProvider> 
            </OverviewProvider>  
          </LinksProvider>  
        </Security>
      );

};

export default App;
